var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:[
    'container',
    _vm.isShopPage && 'container--shop',
    _vm.showShopDefaultHeroSection && _vm.isShopPage && 'container--shop-default-hero',
    _vm.isSkillDivePreSaleActive &&
      !_vm.userHasSkillDive &&
      (_vm.isShopPage || _vm.isSkillDivePreSalePage) &&
      !_vm.isOnePlanAvailable &&
      'container--skill-dive-hero',
    _vm.isSkillDivePreSalePage && 'container--skill-dive-page',
    _vm.isTrialPage && 'container--trial',
    _vm.isAccountPage && 'container--account',
    _vm.isPaymentPage && 'container--payment',
    _vm.isConfirmationPage && 'container--confirmation',
    _vm.isCompletePage && 'container--complete',
    _vm.isEDAPremiumPreSaleActive &&
      !_vm.isAuthenticated &&
      (_vm.isShopPage || _vm.isEDAPremiumPage) &&
      'container--eda-premium-pre-sale' ],attrs:{"id":"app"}},[(_vm.isModalOpen)?_c('div',{staticClass:"container__mask"}):_vm._e(),(_vm.isHeaderShown)?_c('TheHeader'):_vm._e(),(_vm.isShopPage)?_c('ShopHeader'):_vm._e(),(
      !_vm.isOnePlanAvailable &&
      _vm.isPremiumMonthlyPromoActive &&
      (_vm.isShopPage || _vm.isPremiumMonthlyPromoPage)
    )?_c('PremiumMonthlyPromoSection'):_vm._e(),(!_vm.isOnePlanAvailable && _vm.isEDAPremiumPreSaleActive && (_vm.isShopPage || _vm.isEDAPremiumPage))?_c('EDAPremiumPreSaleSection'):_vm._e(),(_vm.newDesign && _vm.showShopDefaultHeroSection && _vm.isShopPage)?_c('ShopDefaultHeroSection'):_vm._e(),(
      _vm.newDesign &&
      _vm.isSkillDivePreSaleActive &&
      !_vm.userHasSkillDive &&
      !_vm.isOnePlanAvailable &&
      (_vm.isShopPage || _vm.isSkillDivePreSalePage)
    )?_c('SkillDiveHeroSection'):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.name})],1),(_vm.isPaymentModalShown)?_c('PaymentForm'):_vm._e(),(_vm.isPaymentSelectorModalShown)?_c('PaymentSelectorModal'):_vm._e(),(_vm.isSignInModalShown)?_c('SignInModal'):_vm._e(),_c('div',{style:(_vm.isIn3dsFlow ? 'display: block' : 'display: none'),attrs:{"id":"recurly-3ds"}}),(_vm.showShopFooter)?_c('ShopFooter'):_c('PaymentFlowFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }